import React, {useState} from 'react';
import cl from "./SearchAndFilter.module.css"
import search_icon from "../../../Assets/icons/search-icon.svg";
import filter from "../../../Assets/icons/Filter.svg";
import FilterModal from "../FilterModal/FilterModal";
import CourseFilter from "../CourseFilter/CourseFilter";

const SearchAndFilter = ({filters, setFilters, entity}) => {
    const [modal, setModal] = useState(false);
    const [searchText, setSearchText] = useState('');

    const updateFilter = (key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: value
        }));
    };

    return (
        <div className={cl.searchAndFilter}>
            {entity === "courses"? (
                <CourseFilter
                    visible={modal}
                    setVisible={setModal}
                    filters={filters}
                    setFilters={setFilters}
                    entity={entity}
                />
            ) : (
                <FilterModal
                    visible={modal}
                    setVisible={setModal}
                    filters={filters}
                    setFilters={setFilters}
                    entity={entity}
                />
            )}
            <div className={cl.searchWrap}>
                <input
                    type={"text"}
                    placeholder={"Search bar"}
                    className={cl.search}
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    onSubmit={() => updateFilter("searchText", searchText)}
                />
                <img
                    src={search_icon}
                    alt={"search icon"}
                    className={cl.searchIcon}
                    onClick={() => updateFilter("searchText", searchText)}
                />
            </div>
            <button className={cl.filterBtn} onClick={() => setModal(true)}>
                Filter
                <img src={filter} alt={"filter"}/>
            </button>
        </div>
    );
};

export default SearchAndFilter;